import { reactLocalStorage } from "reactjs-localstorage";

import { canAccessClientStorageWrapper } from "./embed";

export const CONSENT_MODE_KEY = "consentMode" as const;
export const STAFF_VOLUNTEER_HAS_ALREADY_SCANNED_A_TICKET_KEY = "staffVolunteerHasAlreadyScannedATicket" as const;

type LocalStorageKey =
  | "orderTableFilters"
  | "lastUserViews"
  | typeof CONSENT_MODE_KEY
  | "hasPreviewForm"
  | "peer-to-peer-form-data"
  | "googleSSOSignUpData"
  | "zeffyAdminUser"
  | "page-has-been-force-refreshed"
  | "swiftAidConnectionSkipped"
  | "bypassDashboardUnsupportedBrowser"
  | "bypassFormsUnsupportedBrowser"
  | typeof STAFF_VOLUNTEER_HAS_ALREADY_SCANNED_A_TICKET_KEY;

export const removeFromLocalStorage = canAccessClientStorageWrapper(
  () => (key: LocalStorageKey) => reactLocalStorage.remove(key)
);

export const getFromLocalStorage = canAccessClientStorageWrapper(
  () =>
    <T = string | number | boolean>(key: LocalStorageKey, defaultValue?: T, silent?: boolean) =>
      reactLocalStorage.get<T>(key, defaultValue, silent)
);

export const getObjectFromLocalStorage = canAccessClientStorageWrapper(
  () =>
    <T extends object>(key: LocalStorageKey, defaultValue?: object, silent?: boolean) => {
      const res = reactLocalStorage.getObject(key, defaultValue, silent) as T | undefined;
      if (!res || Object.keys(res).length === 0) {
        return undefined;
      }
      return res;
    }
);

export const setInLocalStorage = canAccessClientStorageWrapper(
  () => (key: LocalStorageKey, value: string | number | boolean) => reactLocalStorage.set(key, value)
);

export const setObjectInLocalStorage = canAccessClientStorageWrapper(
  () => (key: LocalStorageKey, value: object) => reactLocalStorage.setObject(key, value)
);
